'use strict';

var StrategyRowDetailsDirective = function StrategyRowDetailsDirective() {
  return {
    restrict: 'E',
    template: require('../templates/strategy-row-details.html'),
    controller: 'StrategyRowDetailsController',
    scope: {
      strategyDetailsData: '='
    },
    link: function link(scope) {
      scope.$watch('strategyDetailsData', scope.onStrategyDetailsDataChanged);
    }
  };
};
StrategyRowDetailsDirective.$inject = [];
module.exports = StrategyRowDetailsDirective;